import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function EnrichmentUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-4526">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4527">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4528">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4529">
            Local business data enrichment for{' '}
            <span className="text-blue-600" data-id="element-4530">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4531">
            From sales to marketing, see how teams use local business contact
            enrichment to grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4532">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4533">
            <div data-id="element-4534">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4535">
                CRM enrichment
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4536">
                Enrich your Salesforce or HubSpot with verified local business
                contacts, owner emails, and business profiles.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4537">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4538" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4539">
                We enriched 50,000 local business records in our CRM over a
                single weekend.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4540">
                — Rachel K., RevOps lead
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4541">
            <div data-id="element-4542">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4543">
                Sales prospecting
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4544">
                Turn basic local business lists into outreach-ready prospect
                data with verified emails and direct phones.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4545">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4546" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4547">
                Local business contact enrichment doubled our SDR team's connect
                rate.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4548">
                — James T., Sales director
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4549">
            <div data-id="element-4550">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4551">
                Market research
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4552">
                Enrich local business data with tech stacks, revenue, and
                employee counts to identify high-value segments.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4553">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4554" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4555">
                Business profile enrichment helped us find 3 underserved markets
                in our first month.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4556">
                — Lisa P., Strategy manager
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}